import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

export interface Cn54bisCn56BilateralRequest {
  sendingPpo: string;
  receivingPpo: string;
  year: number;
  mailCategory: string;
  cn54bisCn56SummaryRowType: string;
  // Original data fields - optional, not sent in payload
  originalItems?: number;
  originalGrossWeight?: number;
  originalGrossIpk?: number;
  originalGrossP?: number;
  originalGrossG?: number;
  originalGrossE?: number;
  // Bilateral data fields (user edited values) - only these are sent
  bilateralItems: string | null;
  bilateralGrossWeight: string;
  bilateralGrossIpk: string;
  bilateralGrossP: string;
  bilateralGrossG: string;
  bilateralGrossE: string;
  // Additional fields from the API
  activeCells: string[];
  productAsString: string;
}

interface UseCn54bisCn56BilateralMutationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for updating NO3 & CN56 bilateral data
 * 
 * @param options Success and error callback options
 * @returns Mutation hook for updating bilateral data
 */
export const useCn54bisCn56BilateralMutation = (options?: UseCn54bisCn56BilateralMutationOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bilateralData: Cn54bisCn56BilateralRequest) => {
      console.log('Making API request to /cn54bis-cn56-bilateral');
      console.log('Payload:', JSON.stringify(bilateralData, null, 2));
      
              const response = await axios.post('/cn54bis-cn56-bilateral', bilateralData, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      console.log('API Response:', response);
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate relevant queries to refetch the updated data
      queryClient.invalidateQueries({ 
        queryKey: ['cn54bis-cn56-summary'] 
      });
      
      // Call the provided success callback
      options?.onSuccess?.(data);
    },
    onError: (error: any) => {
      console.error('API Error Details:', error);
      if (error?.response) {
        console.error('Error Response:', error.response);
        console.error('Error Data:', error.response.data);
        console.error('Error Status:', error.response.status);
        console.error('Error Headers:', error.response.headers);
      }
      
      // Call the provided error callback
      options?.onError?.(error);
    }
  });
};